import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function NotFound({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <header
        ref={homeRef}
        onScroll={handleScroll}
        className="position-relative w-100 pt-80 height-74 pb-5"
      >
        <div className="position-absolute start-0 top-0 w-100 height-74 linear-gradient-primary-bg z-index-1"></div>
      </header>
      <div className="container py-5" style={{ minHeight: "500px" }}>
        <h1>The page your looking for is not found</h1>
        <Link to="/" className="mx-2">
          Go to Homepage
        </Link>
      </div>
    </>
  );
}

export default NotFound;
